import { createContext } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import type useFetchCurrentPartner from '../views/MainView/hooks/useFetchCurrentPartner';
import type useFetchCurrentUser from '../views/MainView/hooks/useFetchCurrentUser';

type CurrentUser = ReturnType<typeof useFetchCurrentUser>['user'];
type CurrentPartner = ReturnType<typeof useFetchCurrentPartner>['partner'];

interface SwitchPartnerOptions {
  navigate?: NavigateFunction;
  path?: string;
}

interface AuthContextValue {
  partner: CurrentPartner;
  setIsSignupInProgress: (isInProgress: boolean) => void;
  signInErrorMessage?: string;
  switchPartner: (id: string, options?: SwitchPartnerOptions) => void;
  user: CurrentUser;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export default AuthContext;
